import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d2b22c7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trend-ls"
};
const _hoisted_2 = {
  class: "trend-top"
};
const _hoisted_3 = {
  class: "trend-title"
};
const _hoisted_4 = {
  class: "trend-sub"
};
const _hoisted_5 = {
  key: 0,
  class: "trend-hint"
};
const _hoisted_6 = {
  class: "kline-body"
};
const _hoisted_7 = {
  class: "kline-panel"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "kline-panel-title"
}, "亚盘K线", -1));
const _hoisted_9 = {
  key: 0,
  class: "kline-empty"
};
const _hoisted_10 = {
  class: "kline-panel"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "kline-panel-title"
}, "大小盘K线", -1));
const _hoisted_12 = {
  key: 0,
  class: "kline-empty"
};
import { ref, nextTick, onMounted, onBeforeUnmount } from 'vue';
import { buildCandle, renderKline, resolvePan } from './klineBuilder';
export default {
  __name: 'KLineTrendView',
  setup(__props, {
    expose: __expose
  }) {
    const visible = ref(false);
    const head = ref('');
    const company = ref('');
    const rotateNeeded = ref(false);
    const asianEl = ref(null);
    const sizeEl = ref(null);
    const hasAsian = ref(false);
    const hasSize = ref(false);

    // 供 show() 内部使用的快照
    const asianRows = ref([]);
    const sizeRows = ref([]);
    const pan = ref(null);
    const chartAsian = ref(null);
    const chartSize = ref(null);
    const ros = [];
    const draw = () => {
      if (asianEl.value) {
        const rows = asianRows.value;
        if (rows.length) {
          const p = resolvePan(rows, pan.value);
          const b = buildCandle(rows, 'asian', p);
          hasAsian.value = true;
          chartAsian.value = renderKline(asianEl.value, b.xData, b.sData, b.lineList, b.metas, 'asian', true);
        } else {
          hasAsian.value = false;
        }
      }
      if (sizeEl.value) {
        const rows = sizeRows.value;
        if (rows.length) {
          const b = buildCandle(rows, 'size');
          hasSize.value = true;
          chartSize.value = renderKline(sizeEl.value, b.xData, b.sData, b.lineList, b.metas, 'size', true);
        } else {
          hasSize.value = false;
        }
      }
    };
    const show = payload => {
      if (!payload) return;
      head.value = payload.head || '';
      company.value = payload.company || '';
      asianRows.value = payload.asianRows || [];
      sizeRows.value = payload.sizeRows || [];
      pan.value = payload.pan != null ? payload.pan : null;
      syncOrientation();
      visible.value = true;
      nextTick(() => {
        draw();
        // 每次打开重建观察器，容器随旋转/尺寸变化自动重绘
        ros.forEach(ro => ro.disconnect());
        ros.length = 0;
        const els = [asianEl.value, sizeEl.value].filter(Boolean);
        els.forEach(el => {
          const ro = new ResizeObserver(() => {
            const c = el === asianEl.value ? chartAsian.value : chartSize.value;
            if (c) c.resize();
          });
          ro.observe(el);
          ros.push(ro);
        });
      });
    };
    const close = () => {
      visible.value = false;
      ros.forEach(ro => ro.disconnect());
      ros.length = 0;
      if (chartAsian.value) {
        chartAsian.value.dispose();
        chartAsian.value = null;
      }
      if (chartSize.value) {
        chartSize.value.dispose();
        chartSize.value = null;
      }
    };
    const syncOrientation = () => {
      rotateNeeded.value = window.innerWidth <= window.innerHeight;
    };
    const onResize = () => {
      syncOrientation();
      if (!visible.value) return;
      setTimeout(() => {
        if (chartAsian.value) chartAsian.value.resize();
        if (chartSize.value) chartSize.value.resize();
      }, 200);
    };
    onMounted(() => {
      syncOrientation();
      const mql = window.matchMedia('(orientation: landscape)');
      const useMql = typeof mql.addEventListener === 'function';
      useMql ? mql.addEventListener('change', onResize) : window.addEventListener('orientationchange', onResize);
      window.addEventListener('resize', onResize);
    });
    onBeforeUnmount(() => {
      const mql = window.matchMedia('(orientation: landscape)');
      const useMql = typeof mql.removeEventListener === 'function';
      useMql ? mql.removeEventListener('change', onResize) : window.removeEventListener('orientationchange', onResize);
      window.removeEventListener('resize', onResize);
      ros.forEach(ro => ro.disconnect());
      if (chartAsian.value) chartAsian.value.dispose();
      if (chartSize.value) chartSize.value.dispose();
    });

    // eslint-disable-next-line no-undef
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [visible.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["trend-mask", {
          'trend-rotate': rotateNeeded.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(head.value), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(company.value) + " · 近6小时K线", 1), rotateNeeded.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, "↻ 请横屏查看")) : _createCommentVNode("", true), _createElementVNode("span", {
        class: "trend-close",
        onClick: close
      }, "✕")]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _withDirectives(_createElementVNode("div", {
        ref_key: "asianEl",
        ref: asianEl,
        class: "kline-canvas"
      }, null, 512), [[_vShow, hasAsian.value]]), !hasAsian.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, "近6小时暂无亚盘变动")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _withDirectives(_createElementVNode("div", {
        ref_key: "sizeEl",
        ref: sizeEl,
        class: "kline-canvas"
      }, null, 512), [[_vShow, hasSize.value]]), !hasSize.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, "近6小时暂无大小盘变动")) : _createCommentVNode("", true)])])])], 2)) : _createCommentVNode("", true)]);
    };
  }
};